import React, { createContext, useContext, useState, useCallback } from "react";

export const FeedAnimationContext = createContext();

export const FeedAnimationProvider = ({ children }) => {
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const [showDeleteSuccessAnimation, setShowDeleteSuccessAnimation] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");

  const showSuccess = useCallback(() => {
    setShowSuccessAnimation(true);
  }, []);

  const showDeleteSuccess = useCallback((message) => {
    setDeleteMessage(message);
    setShowDeleteSuccessAnimation(true);
  }, []);

  const hideAnimations = useCallback(() => {
    setShowSuccessAnimation(false);
    setShowDeleteSuccessAnimation(false);
    setDeleteMessage("");
  }, []);

  return (
    <FeedAnimationContext.Provider
      value={{
        showSuccessAnimation,
        showDeleteSuccessAnimation,
        deleteMessage,
        showSuccess,
        showDeleteSuccess,
        hideAnimations,
      }}
    >
      {children}
    </FeedAnimationContext.Provider>
  );
};

export const useFeedAnimation = () => {
  const context = useContext(FeedAnimationContext);
  if (!context) {
    throw new Error('useFeedAnimation must be used within a FeedAnimationProvider');
  }
  return context;
};